import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { SMS_TEMPLATE_CONTROLLER } from "api/Service";

export const useSmsTemplatesAll = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["smsTemplatesAll", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${SMS_TEMPLATE_CONTROLLER}`
      );

      return response.data;
    },
    enabled: !!tenantVal,
  });
};
